/* Joeps keuzehulp-quiz. Data-driven: sections/keuzehulp-quiz.liquid levert window.JP_QUIZ
   (per categorie een vragenset) + window.JP_QUIZ_PRODUCTS (ingesloten productdata voor
   inline scoring). Elke keuze mapt op een echt product-metafield. Meeste categorieen scoren
   inline (top-5 beste match); hoesje = redirect-modus (gefilterde collectie ophalen).
   Vraagtypes: single (kies 1) en multi (kies meerdere = checklist, "contains"-scoring). */
(function () {
  var root = document.querySelector('[data-quiz-root]');
  if (!root || !window.JP_QUIZ) return;
  var CONFIG = window.JP_QUIZ;

  function param() {
    var m = location.search.match(/[?&]c=([a-z]+)/);
    return m ? m[1] : (root.getAttribute('data-quiz-default') || 'telefoon');
  }
  var cat = param();
  var quiz = CONFIG[cat];
  if (!quiz) { quiz = CONFIG['telefoon']; cat = 'telefoon'; }

  var answers = {};   // key -> single {value,label} | multi {multi:true,values:[],labels:[],label}
  var step = 0;
  var PRODUCTS = (window.JP_QUIZ_PRODUCTS || {})[cat] || null;  // null = redirect-modus (hoesje)

  // De productdata komt uit /collections/<handle>?view=quizdata en niet meer uit
  // de pagina zelf. Dat scheelt de bezoeker een paar honderd kilobyte voor vier
  // categorieen die hij toch niet doorloopt, en het haalt de stille grens van
  // 250 producten weg: Liquid pagineert maximaal 250, dus van de 448 telefoons
  // kwamen er 198 nooit in de aanbevelingen.
  var BRON = (window.JP_QUIZ_SRC || {})[cat] || null;
  var laadt = false;
  function laadProducten(klaar) {
    if (PRODUCTS || !BRON || laadt) return;
    laadt = true;
    // Sleutel met het aantal erin: verandert de catalogus, dan vervalt de cache vanzelf.
    var sleutel = 'jpquizdata:' + BRON.coll + ':' + BRON.total;
    try {
      var bewaard = sessionStorage.getItem(sleutel);
      if (bewaard) { PRODUCTS = JSON.parse(bewaard); laadt = false; klaar(); return; }
    } catch (e) {}
    var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var verzoeken = [];
    for (var i = 1; i <= (BRON.pages || 1); i++) {
      // Geen Accept: application/json meesturen. Shopify negeert dan het
      // view-sjabloon en stuurt zijn eigen collectie-JSON terug, zonder items,
      // waardoor de quiz stilletjes op nul producten uitkomt.
      verzoeken.push(
        fetch(wortel.replace(/\/$/, '') + '/collections/' + BRON.coll + '?view=quizdata&page=' + i)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (tekst) { try { return JSON.parse(tekst); } catch (e) { return { items: [] }; } })
          .catch(function () { return { items: [] }; })
      );
    }
    Promise.all(verzoeken).then(function (delen) {
      var alles = [];
      delen.forEach(function (d) { alles = alles.concat((d && d.items) || []); });
      PRODUCTS = alles;
      // Een lege uitkomst niet bewaren: dan blijft een mislukte ophaalpoging
      // de rest van het bezoek hangen en ziet de klant nooit resultaten.
      if (alles.length) { try { sessionStorage.setItem(sleutel, JSON.stringify(alles)); } catch (e) {} }
      laadt = false;
      klaar();
    });
  }

  // Status bewaren per categorie: klant klikt een resultaat aan (PDP) en komt
  // terug -> de quiz staat nog precies waar hij was (wisselen tussen lijst en PDP).
  var STORE_KEY = 'jpquiz:' + cat;
  function saveState() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ a: answers, s: step })); } catch (e) {}
  }
  function clearState() {
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
  }
  (function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var st = JSON.parse(raw);
      if (st && st.a && typeof st.s === 'number') { answers = st.a; step = st.s; }
    } catch (e) {}
  }());

  // Toestel-modellen uit het accessoires-mega in de header (label + collectie-basis).
  // Elk model heeft gegarandeerd een /collections/<base>-acc collectie.
  var MODELS = [];
  (function () {
    var seen = {};
    document.querySelectorAll('[data-phpanel] a[href$="-acc"]').forEach(function (a) {
      if (a.classList.contains('phmega__all')) return;
      /* Het menu verbergt een model zodra zijn collectie leeg is, maar de link
         blijft in de DOM staan. Zonder deze regel bood de keuzehulp toestellen aan
         waar geen enkel hoesje voor is, en las de klant dat pas op het eindscherm,
         na vijf vragen. */
      if (a.hasAttribute('hidden')) return;
      var base = a.getAttribute('href').replace('/collections/', '').replace(/-acc$/, '');
      if (seen[base]) return; seen[base] = 1;
      MODELS.push({ label: a.textContent.trim(), base: base });
    });
  }());

  // Conditionele vragen: S Pen alleen bij toestellen met S Pen (Fold/Ultra/Tab S),
  // ringhouder alleen bij Z Flip (daar bestaan onze ring cases voor).
  // Geen toestel gekozen -> deze niche-vragen verbergen (klant weet dat niet los van z'n toestel).
  function visibleQuestions() {
    return quiz.questions.filter(function (q) {
      if (!q.showIf) return true;
      var d = answers.__device;
      if (q.showIf === 'spen') return !!d && /fold|ultra|tab\s*s/i.test(d.label);
      if (q.showIf === 'ring') return !!d && /flip/i.test(d.label);
      return true;
    });
  }

  function h(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  // filterKey -> ingesloten productveld (quiz-products.liquid)
  var FIELD = {
    'filter.p.m.custom.besturingssysteem': 'os',
    'filter.p.m.custom.opslag_klasse': 'ops',
    'filter.p.m.custom.werkgeheugen': 'wg',
    'filter.p.m.custom.schermgrootte': 'scr',
    'filter.p.m.custom.netwerk_5g': 'net',
    'filter.p.m.custom.processor': 'chip',
    'filter.p.m.custom.camera_mp': 'cam',
    'filter.p.m.custom.accu_capaciteit': 'accu',
    'filter.p.m.custom.extra_functies': 'extra',
    'filter.p.m.custom.formfactor': 'ff',
    'filter.p.m.custom.connectiviteit': 'conn',
    'filter.p.m.custom.model_lijn': 'mlijn',
    'filter.p.m.custom.mac_lijn': 'maclijn',
    'filter.p.m.custom.mac_gpu': 'macgpu',
    'filter.p.m.custom.mac_kleur': 'mackl',
    'filter.p.m.custom.audio_type': 'atype',
    'filter.p.m.custom.audio_draadloos': 'adraad',
    'filter.p.m.custom.audio_anc': 'aanc',
    'filter.p.m.custom.audio_connector': 'acon',
    'filter.p.m.custom.oplader_type': 'otype',
    'filter.p.m.custom.oplader_vermogen': 'overm',
    'filter.p.m.custom.oplader_apparaat': 'oapp',
    'filter.p.m.custom.oplader_poorten': 'opoort',
    'filter.p.m.custom.oplader_kabel': 'okabel',
    'filter.p.m.custom.oplader_features': 'ofeat',
    'filter.p.m.custom.oplader_kleur': 'okleur',
    'filter.p.m.custom.hoesje_type': 'htype',
    'filter.p.m.custom.hoesje_materiaal': 'hmat',
    'filter.p.m.custom.hoesje_pasjes': 'hpas',
    'filter.p.m.custom.hoesje_ring': 'hring',
    'filter.p.m.custom.hoesje_spen': 'hspen',
    'filter.p.m.custom.color': 'col',
    'filter.p.vendor': 'vr'
  };

  // zelfde prijsformaat als de PDP/kaarten (snippets/jprice.liquid):
  // geen valutateken, duizendtal-punt, hele euro's als "1.129,-", echte centen behouden
  function money(cents) {
    return (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, ',-');
  }
  function inBudget(cents, range) {
    if (!range) return false;
    var lo = +range.split('-')[0] * 100, hi = +range.split('-')[1] * 100;
    return cents >= lo && cents <= hi;
  }
  // productveld kan een string of een array (lijst-metafield) zijn
  function fieldHas(pf, v) {
    if (pf == null) return false;
    if (Array.isArray(pf)) return pf.indexOf(v) !== -1;
    return pf === v;
  }

  function scored() {
    var answered = quiz.questions.filter(function (q) { return FIELD[q.key] && answers[q.key]; });
    var hard = answered.filter(function (q) { return q.hard; });
    var soft = answered.filter(function (q) { return !q.hard; });
    var budget = answers['__budget'] && answers['__budget'].value;

    var pool = PRODUCTS.filter(function (p) {
      return hard.every(function (q) {
        var a = answers[q.key], f = p[FIELD[q.key]];
        if (a.multi) return a.values.some(function (v) { return fieldHas(f, v); });
        return fieldHas(f, a.value);
      });
    });
    var maxMatch = 0;
    soft.forEach(function (q) { maxMatch += (answers[q.key].multi ? answers[q.key].values.length : 1); });
    if (budget) maxMatch += 1;

    var list = pool.map(function (p) {
      var s = 0;
      soft.forEach(function (q) {
        var a = answers[q.key], f = p[FIELD[q.key]];
        if (a.multi) { a.values.forEach(function (v) { if (fieldHas(f, v)) s++; }); }
        else if (fieldHas(f, a.value)) s++;
      });
      if (budget && p.pr > 0 && inBudget(p.pr, budget)) s++;
      return { p: p, s: s };
    });
    list.sort(function (a, b) {
      if (b.s !== a.s) return b.s - a.s;
      if (a.p.av !== b.p.av) return a.p.av ? -1 : 1;
      return (a.p.pr || 0) - (b.p.pr || 0);
    });
    // dedup op titel (kleuren/jaartal/INT-suffix samenvouwen tot uniek model)
    var COL = 'Awesome\\s*\\w+|Zwart|Wit|Blauw|Blauwgroen|Donkerblauw|Lichtblauw|Hemelsblauw|IJsblauw|Ijsblauw|Iceblue|Icyblue|Rood|Groen|Donkergroen|Lichtgroen|Olive|Olijf|Geel|Goudgeel|Lime|Limegroen|Paars|Donkerpaars|Lichtpaars|Roze|Grijs|Grijsgroen|Titaniumgrijs|Zilver|Goud|Oranje|Titanium\\w*|Mint|Menthol|Lavendel|Beige|Bruin|Creme|Crème|Ultramarine|Sterrenlicht|Middernacht|Spacezwart|Spacegrijs|Spacegrey|Cobolt\\s*Violet|Kobalt|Cobalt|Marineblauw|Navy|Taupe|Dark\\s*Violet|Lila|Lilac|Perzik|Koraal|Coral|Sandstone|Sierra|Amber|Violet|Graphite|Grafiet|Black|White|Blue|Green|Yellow|Purple|Pink|Gray|Grey|Gold|Silver|Orange';
    var re = new RegExp('\\s*[-–]?\\s*(' + COL + ')\\s*$', 'i');
    var seen = {}, uniq = [];
    list.forEach(function (it) {
      var key = it.p.t
        .replace(/\s*INT\s*(Engels|English)\s*$/i, '')
        .replace(/\s*\(20\d\d\)\s*$/, '')
        .replace(re, '').trim();
      if (!seen[key]) { seen[key] = 1; uniq.push(it); }
    });
    return { list: uniq, maxMatch: maxMatch };   // volledige gescoorde lijst; UI toont in blokken van 5
  }

  function buildUrl() {
    var url = quiz.collection;
    if (answers.__collection) url = answers.__collection;
    var avail = (window.JP_AVAIL || {})[url] || null;
    var qs = [];
    quiz.questions.forEach(function (q) {
      if (q.key.indexOf('filter.') !== 0) return;   // __budget e.d. zijn geen echte filters
      var a = answers[q.key];
      if (!a) return;
      var vals = a.multi ? a.values : (a.value ? [a.value] : []);
      vals.forEach(function (v) {
        if (!v) return;
        if (q.key === 'filter.p.vendor' && avail && avail.indexOf(v) === -1) return;
        qs.push(encodeURIComponent(q.key) + '=' + encodeURIComponent(v));
      });
    });
    return url + (qs.length ? ('?' + qs.join('&')) : '');
  }

  function advance() {
    step++; render();
    // alleen scrollen als de vraag niet (volledig) in beeld is; anders stilhouden = geen springen
    var r = root.getBoundingClientRect();
    if (r.top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function render() {
    saveState();   // elke statuswijziging rendert -> status altijd actueel bewaard
    root.innerHTML = '';
    var vq = visibleQuestions();
    var total = vq.length;
    if (step > total) step = total;
    var prog = h('div', 'quiz__prog');
    for (var i = 0; i <= total; i++) {
      prog.appendChild(h('span', 'quiz__dot' + (i < step ? ' is-done' : (i === step ? ' is-cur' : ''))));
    }

    if (step < total) {
      var q = vq[step];
      var isMulti = q.type === 'multi';
      var card = h('div', 'quiz__card');
      card.appendChild(prog);
      card.appendChild(h('span', 'quiz__step', 'Stap ' + (step + 1) + ' van ' + total));
      card.appendChild(h('h2', 'quiz__q', q.q));
      if (q.hint) card.appendChild(h('p', 'quiz__hint', q.hint));
      if (isMulti) card.appendChild(h('p', 'quiz__multi-note', 'Kies alles wat past. Klik daarna op Volgende.'));

      if (q.type === 'device') {                 // toestel-zoeker (hoesje: eerst je telefoon)
        var dwrap = h('div', 'quiz__device');
        var inp = h('input', 'quiz__dev-input');
        inp.type = 'search';
        inp.placeholder = q.placeholder || 'Zoek je model, bijv. iPhone 16 of Galaxy S24';
        inp.setAttribute('autocomplete', 'off');
        var sug = h('div', 'quiz__dev-sug');
        function showSug(term) {
          sug.innerHTML = '';
          var t = (term || '').toLowerCase().trim();
          var hits = t ? MODELS.filter(function (m) { return m.label.toLowerCase().indexOf(t) !== -1; }) : [];
          hits.slice(0, 8).forEach(function (m) {
            var b = h('button', 'quiz__dev-hit', m.label);
            b.type = 'button';
            b.addEventListener('click', function () {
              answers.__device = { label: m.label, base: m.base };
              answers.__collection = '/collections/' + m.base + '-acc';
              advance();
            });
            sug.appendChild(b);
          });
          if (t && !hits.length) sug.appendChild(h('p', 'quiz__hint', 'Geen model gevonden; probeer bijv. "iPhone 15" of "Galaxy A56".'));
        }
        inp.addEventListener('input', function () { showSug(inp.value); });
        dwrap.appendChild(inp); dwrap.appendChild(sug);
        if (answers.__device) {
          var curDev = h('p', 'quiz__multi-note', 'Gekozen: <b>' + answers.__device.label + '</b>');
          dwrap.appendChild(curDev);
        }
        var skipB = h('button', 'quiz__opt quiz__opt--skip', '<span class="quiz__opt-l">Weet ik niet / sla over</span><span class="quiz__opt-sub">toon hoesjes voor alle modellen</span>');
        skipB.type = 'button';
        skipB.addEventListener('click', function () {
          delete answers.__device; delete answers.__collection;
          advance();
        });
        dwrap.appendChild(skipB);
        card.appendChild(dwrap);
        var nav0 = h('div', 'quiz__nav');
        if (step > 0) {
          var back0 = h('button', 'quiz__back', '&larr; Vorige');
          back0.type = 'button';
          back0.addEventListener('click', function () { step--; render(); });
          nav0.appendChild(back0);
        }
        card.appendChild(nav0);
        root.appendChild(card);
        setTimeout(function () { inp.focus(); }, 50);
        return;
      }

      var cur = answers[q.key];
      var opts = h('div', 'quiz__opts' + (q.opts.length > 4 ? ' quiz__opts--grid' : ''));
      q.opts.forEach(function (o) {
        var skip = (o.value === '' || o.value == null);
        var selected = !skip && isMulti && cur && cur.multi && cur.values.indexOf(o.value) !== -1;
        var b = h('button', 'quiz__opt' + (selected ? ' is-sel' : ''),
          (o.ico ? '<span class="quiz__opt-ico">' + o.ico + '</span>' : '') +
          '<span class="quiz__opt-l">' + o.label + '</span>' +
          (o.sub ? '<span class="quiz__opt-sub">' + o.sub + '</span>' : ''));
        b.type = 'button';
        b.addEventListener('click', function () {
          if (skip) {                         // "Maakt niet uit" -> wis + door
            delete answers[q.key];
            if (q.resets_collection) delete answers.__collection;
            advance(); return;
          }
          if (isMulti) {                       // toggle, blijf op de vraag
            var a = answers[q.key];
            if (!a || !a.multi) a = answers[q.key] = { multi: true, values: [], labels: [] };
            var idx = a.values.indexOf(o.value);
            if (idx === -1) { a.values.push(o.value); a.labels.push(o.label); }
            else { a.values.splice(idx, 1); a.labels.splice(idx, 1); }
            a.label = a.labels.join(', ');
            if (!a.values.length) delete answers[q.key];
            render();
          } else {                             // single -> kies + door
            answers[q.key] = { value: o.value, label: o.label };
            if (o.collection) answers.__collection = o.collection;
            else if (q.resets_collection) delete answers.__collection;
            advance();
          }
        });
        opts.appendChild(b);
      });
      card.appendChild(opts);

      var nav = h('div', 'quiz__nav');
      if (step > 0) {
        var back = h('button', 'quiz__back', '&larr; Vorige');
        back.type = 'button';
        back.addEventListener('click', function () { step--; render(); });
        nav.appendChild(back);
      }
      if (isMulti) {
        var next = h('button', 'quiz__next', 'Volgende &rarr;');
        next.type = 'button';
        next.addEventListener('click', function () { advance(); });
        nav.appendChild(next);
      }
      card.appendChild(nav);
      root.appendChild(card);
    } else {
      var card2 = h('div', 'quiz__card quiz__card--result');
      card2.appendChild(prog);
      card2.appendChild(h('span', 'quiz__step', 'Klaar!'));
      var rtitle = quiz.result_title || 'Dit past bij jou';
      if (answers.__device) rtitle = 'Voor jouw ' + answers.__device.label;
      card2.appendChild(h('h2', 'quiz__q', rtitle));
      var sumWrap = h('div', 'quiz__summary');
      if (answers.__device) sumWrap.appendChild(h('span', 'quiz__chip', '<b>Toestel:</b> ' + answers.__device.label));
      vq.forEach(function (q) {
        if (!FIELD[q.key] && q.key !== '__budget') return;
        var a = answers[q.key];
        sumWrap.appendChild(h('span', 'quiz__chip', '<b>' + q.short + ':</b> ' + (a ? a.label : 'Maakt niet uit')));
      });
      card2.appendChild(sumWrap);

      if (!PRODUCTS && BRON) {
        // De data is nog onderweg. Iets tonen is beter dan een lege kaart, en
        // zodra hij binnen is tekent render() dit blok opnieuw met resultaten.
        card2.appendChild(h('p', 'quiz__matchlead', 'Even je resultaten ophalen...'));
        laadProducten(render);
      } else if (PRODUCTS && PRODUCTS.length) {
        // VOLLEDIGE gescoorde lijst in een scrollbare grid (owner: alles zichtbaar, geen collectie-link)
        var res = scored();
        card2.appendChild(h('p', 'quiz__matchlead', res.list.length ? (res.list.length + ' passend' + (res.list.length === 1 ? ' product' : 'e producten') + ', gesorteerd op hoe goed ze bij je keuzes passen.') : 'Geen resultaat met deze combinatie.'));
        var grid = h('div', 'quiz__results quiz__results--scroll');
        res.list.forEach(function (item, idx) {
          var p = item.p;
          var badge = res.maxMatch && item.s >= res.maxMatch ? '<span class="quiz__res-badge">Beste match</span>' : (idx === 0 ? '<span class="quiz__res-badge">Aanrader</span>' : '');
          var priceHtml = p.pr > 0 ? money(p.pr) : 'Prijs op aanvraag';
          var pre = (!p.av && p.ed) ? String(p.ed) : '';
          var stock = p.av ? '' : (pre ? '<span class="quiz__res-oos">' + pre + '</span>' : '<span class="quiz__res-oos">Tijdelijk uitverkocht</span>');
          var cardEl = h('a', 'quiz__res' + (p.av || pre ? '' : ' is-oos'),
            '<span class="quiz__res-media"><img src="' + p.i + '" alt="" loading="lazy">' + badge + '</span>' +
            '<span class="quiz__res-body"><span class="quiz__res-name">' + p.t + '</span>' + stock +
            '<span class="quiz__res-price">' + priceHtml + '</span></span>');
          cardEl.href = p.u;
          grid.appendChild(cardEl);
        });
        card2.appendChild(grid);
      } else {
        // redirect-modus (hoesje): haal de GEFILTERDE collectie op en toon de eerste 5 kaarten.
        // Progressieve versoepeling: 0 resultaten -> laat het minst belangrijke filter los
        // (laatst gestelde vraag eerst, de eerste vraag/soort nooit) tot er iets te tonen is.
        var grid2 = h('div', 'quiz__results');
        grid2.innerHTML = '<p class="quiz__matchlead">Even zoeken&hellip;</p>';
        card2.appendChild(grid2);
        var allLink = h('a', 'quiz__res-all', 'Bekijk alle passende producten &rarr;');
        allLink.href = buildUrl();
        card2.appendChild(allLink);

        var activeQs = vq.filter(function (q) {
          return q.key.indexOf('filter.') === 0 && answers[q.key];
        });
        // los-laat-volgorde: er wordt telkens ACHTERAAN losgelaten; toestel-specifieke
        // wensen (S Pen/ring, showIf) vooraan zetten zodat die als laatste sneuvelen
        activeQs.sort(function (a, b) { return (a.showIf ? 0 : 1) - (b.showIf ? 0 : 1); });
        var dropped = [];
        function urlWith(qs) {
          var url = answers.__collection || quiz.collection;
          var parts = [];
          qs.forEach(function (q) {
            var a = answers[q.key];
            var vals = a.multi ? a.values : [a.value];
            vals.forEach(function (v) {
              if (v) parts.push(encodeURIComponent(q.key) + '=' + encodeURIComponent(v));
            });
          });
          // model-collectie (<base>-acc) bevat OOK protectors/laders. Zit er in deze fetch
          // geen enkel hoesje-filter (die beperken zelf al tot hoesjes), geef dan alle
          // hoesje-soorten als OR-filter mee zodat er geen protector/lader tussen komt.
          var heeftHoesFilter = qs.some(function (q) { return q.key.indexOf('filter.p.m.custom.hoesje_') === 0; });
          if (/-acc$/.test(url) && !heeftHoesFilter) {
            ['Back cover', 'Flip case', 'Bookcase (wallet)', 'Met standaard', 'Antishock', 'Transparant'].forEach(function (v) {
              parts.push(encodeURIComponent('filter.p.m.custom.hoesje_type') + '=' + encodeURIComponent(v));
            });
          }
          return url + (parts.length ? ('?' + parts.join('&')) : '');
        }
        function tryFetch(qs) {
          var dest = urlWith(qs);
          return fetch(dest).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = [].slice.call(doc.querySelectorAll('.jp-card'));
            /* Het echte aantal staat in de balk van de collectiepagina. De kaarten
               hier zijn maar pagina 1 (standaard 12) en daarna vouwen we ook nog
               kleurvarianten samen, dus tellen wat we in handen hebben gaf "7
               passende hoesjes" terwijl de pagina erachter er 41 toonde. */
            var totEl = doc.querySelector('.plp__count b');
            var totaal = totEl ? parseInt(totEl.textContent.replace(/\D/g, ''), 10) : 0;
            if (!cards.length && qs.length > 0) {
              // ook het laatste filter mag los: de (model-)collectie zelf blijft altijd staan
              dropped.unshift(qs[qs.length - 1].short);
              return tryFetch(qs.slice(0, -1));
            }
            return { cards: cards, dest: dest, totaal: totaal || cards.length };
          });
        }
        tryFetch(activeQs).then(function (res) {
          var cards = res.cards;
          allLink.href = res.dest;
          var budget = answers['__budget'] && answers['__budget'].value;
          function cardCents(c) {
            var pe = c.querySelector('[class*="price"]');
            if (!pe) return null;
            var m = pe.textContent.replace(/\s/g, '').match(/(\d+)(?:[,.](\d{2}))?/);
            return m ? (+m[1]) * 100 + (+(m[2] || 0)) : null;
          }
          // losgelaten wensen + budget = ZACHTE ranking op de gevonden kaarten
          // (zwart-wens die losgelaten is -> zwarte variant toch bovenaan)
          var droppedVals = [];
          activeQs.forEach(function (q) {
            if (dropped.indexOf(q.short) === -1) return;
            var a = answers[q.key];
            (a.multi ? a.values : [a.value]).forEach(function (v) { if (v) droppedVals.push(v.toLowerCase()); });
          });
          if (cards.length && (droppedVals.length || budget)) {
            cards = cards.map(function (c, i) {
              var txt = c.textContent.toLowerCase();
              var s = 0;
              droppedVals.forEach(function (v) { if (txt.indexOf(v) !== -1) s++; });
              var cents = cardCents(c);
              if (budget && cents != null && inBudget(cents, budget)) s++;
              return { c: c, s: s, i: i };
            }).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (x) { return x.c; });
          }
          // kleurvarianten van hetzelfde model samenvouwen (variatie in de top 5)
          var seenBase = {};
          cards = cards.filter(function (c) {
            var name = ((c.querySelector('.jp-card__name, h3') || {}).textContent || '').trim();
            var base = name.replace(/\s*[|\-–]?\s*(Zwart|Wit|Blauw|Blauwgroen|Donkerblauw|Lichtblauw|IJsblauw|Rood|Groen|Donkergroen|Lichtgroen|Geel|Goudgeel|Paars|Donkerpaars|Lichtpaars|Violet|Roze|Grijs|Grijsgroen|Titaniumgrijs|Zilver|Goud|Oranje|Mint|Menthol|Lavendel|Beige|Bruin|Creme|Crème|Navy|Marineblauw|Taupe|Lila|Lilac|Perzik|Koraal|Amber|Graphite|Grafiet|Transparant|Clear)\s*$/i, '').trim();
            if (seenBase[base]) return false;
            seenBase[base] = 1; return true;
          });
          grid2.className = 'quiz__results quiz__results--scroll';
          grid2.innerHTML = '';
          if (!cards.length) {
            // ook na volledige versoepeling niets: eerlijk melden (bv. model zonder hoesjes-aanbod)
            var leeg = answers.__device
              ? 'Voor de <b>' + answers.__device.label + '</b> hebben we nog geen hoesjes. Bekijk hieronder alle hoesjes.'
              : 'Geen product gevonden met deze combinatie. Bekijk de hele collectie hieronder.';
            grid2.innerHTML = '<p class="quiz__matchlead">' + leeg + '</p>';
            allLink.href = quiz.collection;
            allLink.innerHTML = 'Bekijk alle hoesjes &rarr;';
            return;
          }
          var tot = res.totaal || cards.length;
          var lead2 = answers.__device
            ? (tot + ' passend' + (tot === 1 ? ' hoesje' : 'e hoesjes') + ' voor de ' + answers.__device.label + '.')
            : (tot + ' passend' + (tot === 1 ? ' product' : 'e producten') + ' voor jouw wensen.');
          if (dropped.length) lead2 += ' Op ' + dropped.join(' en ') + ' was geen exacte match; die hebben we losgelaten voor meer keuze.';
          card2.insertBefore(h('p', 'quiz__matchlead', lead2), grid2);
          cards.forEach(function (c) {
            var a = c.querySelector('a[href*="/products/"]') || c.querySelector('a');
            var name = (c.querySelector('.jp-card__name, h3') || {}).textContent || '';
            var priceEl = c.querySelector('[class*="price"]');
            var price = priceEl ? priceEl.textContent.trim() : '';
            var img = c.querySelector('img');
            var txtFlat = c.textContent.replace(/\s+/g, ' ').trim();
            var oos = /uitverkocht/i.test(c.textContent);
            var preM = txtFlat.match(/In bestelling,\s*leverbaar vanaf\s*\d{2}-\d{2}-\d{4}/i);
            var preTxt = preM ? preM[0] : '';
            var el = h('a', 'quiz__res' + (oos && !preTxt ? ' is-oos' : ''),
              '<span class="quiz__res-media">' + (img ? '<img src="' + (img.getAttribute('src') || '') + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="quiz__res-body"><span class="quiz__res-name">' + name.trim() + '</span>' +
              (preTxt ? '<span class="quiz__res-oos">' + preTxt + '</span>' : (oos ? '<span class="quiz__res-oos">Tijdelijk uitverkocht</span>' : '')) +
              (price ? '<span class="quiz__res-price">' + price + '</span>' : '') + '</span>');
            el.href = a ? a.getAttribute('href') : res.dest;
            grid2.appendChild(el);
          });
        }).catch(function () {
          grid2.innerHTML = '';
          var go = h('a', 'jp-btn jp-btn--cart jp-btn--lg jp-btn--block', (quiz.result_cta || 'Toon resultaten') + ' &rarr;');
          go.href = buildUrl();
          grid2.appendChild(go);
        });
      }

      var redo = h('button', 'quiz__back', 'Opnieuw beginnen');
      redo.type = 'button';
      redo.addEventListener('click', function () { clearState(); answers = {}; step = 0; render(); });
      card2.appendChild(redo);
      root.appendChild(card2);
    }
  }

  var head = document.querySelector('[data-quiz-head]');
  if (head && quiz.head) head.textContent = quiz.head;
  var lead = document.querySelector('[data-quiz-lead]');
  if (lead && quiz.lead) lead.textContent = quiz.lead;

  render();
  // Alvast ophalen terwijl de bezoeker de vragen beantwoordt, zodat het
  // resultaat er staat op het moment dat hij klaar is. Alleen opnieuw tekenen
  // als hij al op het resultaat staat; midden in een vraag zou dat de kaart
  // onnodig laten knipperen.
  laadProducten(function () { if (step >= visibleQuestions().length) render(); });
}());
